export class ReportRequestObject{
  constructor() {
    this.ReportParams = [];
  }

  public ReportPath: string;
  public ReportParams: ReportParameter[];
}

export class ReportParameter {

  constructor() { }

  public Key: string;
  public Value: string;

}
